@if (isExtendedSidebar()) {
  <app-extended-side-nav [shouldShowPortfolios]="shouldShowPortfolios"
    [shouldDisplayManualReview]="shouldDisplayManualReview()" [bypassBackendCache]='bypassBackendCache'
    [switchOnProfiler]='switchOnProfiler' [isAdmin]="userIsTenantAdmin()" [isInternalDeveloper]="userIsDeveloper()"
    [showBorrowerOptions]="showBorrowerOptions" [showSpreadingTemplates]="showSpreadingTemplates"
    [showReporting]="showReporting" [showApiKeysOption]="showApiKeysOption" (toggleSidebar)="toggleSidebar()"
    (restCommander)="restCommander()" (triggerError)="triggerError()" (cacheCommander)="cacheCommander()"
    (taxFormTemplateEditor)="taxFormTemplateEditor()" (toggleBypassCache)="toggleBypassCache()"
    (toggleProfiler)="toggleProfiler()" (choosePortfolio)="choosePortfolio($event)"
    (chooseBorrower)="chooseBorrower($event)">
  </app-extended-side-nav>
}

@if (isNormalSidebar()) {
  <app-minimized-side-nav [shouldShowPortfolios]="shouldShowPortfolios"
    [shouldDisplayManualReview]="shouldDisplayManualReview()" [bypassBackendCache]='bypassBackendCache'
    [switchOnProfiler]='switchOnProfiler' [showSpreadingTemplates]="showSpreadingTemplates"
    [showReporting]="showReporting" [showApiKeysOption]="showApiKeysOption" [isAdmin]="userIsTenantAdmin()"
    [isInternalDeveloper]="userIsDeveloper()" [showBorrowerOptions]="showBorrowerOptions"
    (triggerError)="triggerError()" (toggleSidebar)="toggleSidebar()" (toggleBypassCache)="toggleBypassCache()"
    (toggleProfiler)="toggleProfiler()" (restCommander)="restCommander()" (cacheCommander)="cacheCommander()"
    (taxFormTemplateEditor)="taxFormTemplateEditor()">
  </app-minimized-side-nav>
}